var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.00000000000001,
    height: 48.00000000000001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m47.87111,24.05427c0,13.1436 -10.64233,23.79785 -23.76888,23.79785c-13.12655,0 -23.76888,-10.65425 -23.76888,-23.79785c0,-13.1436 10.64233,-23.79785 23.76888,-23.79785c13.12655,0 23.76888,10.65425 23.76888,23.79785",
    fill: "#c6c6c6",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "white",
    id: "svg_2",
    d: "m21.17006,13.57282l5.58289,0c0.94109,0 1.77307,0.60183 2.06858,1.49411l0.47282,1.41945l3.39611,0c1.60486,0 2.90966,1.30655 2.90966,2.91358l0,11.65428c0,1.60702 -1.30479,2.91358 -2.90966,2.91358l-17.45789,0c-1.60713,0 -2.90966,-1.30655 -2.90966,-2.91358l0,-11.65428c0,-1.60702 1.30252,-2.91358 2.90966,-2.91358l3.39611,0l0.47282,-1.41945c0.29551,-0.89228 1.12749,-1.49411 2.06858,-1.49411l0,0l-0.00001,0zm2.79144,16.02465c2.40955,0 4.36447,-1.95756 4.36447,-4.37035c0,-2.45377 -1.95492,-4.37035 -4.36447,-4.37035c-2.45047,0 -4.36447,1.91659 -4.36447,4.37035c0,2.4128 1.91401,4.37035 4.36447,4.37035z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.33f4a22084546b72aa314bbf40f11155.svg";
export { ForwardRef as ReactComponent };